import { FaInstagram, FaFacebook } from "react-icons/fa";
import "./InstagramHashtag.css";

export default function InstagramHashtag() {
  return (
    <section className="seccion-instagram">
      {/* Capa translúcida */}
      <div className="overlay"></div>

      <div className="contenido-instagram">
        <h3>#BodaJulianayMartin</h3>
        <p>Compartí tus fotos con el hashtag</p>
        <div className="iconos-redes">
          <FaInstagram className="icono-instagram" />
          <FaFacebook className="icono-facebook" />
        </div>
      </div>
    </section>
  );
}
